import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import style from './styles/style.module.css';

class XorOption extends PureComponent {
    constructor( props ) {
        super( props );
    }
    render() {
        const { value, checked, onChange, name, label } = this.props;
        var inlineStyle = { ...this.props.style };

        return (
            <label className={ `${ this.props.className } ${ style.xorSwitchOption }` }
            style={ inlineStyle }
            data-active={ checked }>
                <input type='radio'
                value={ value }
                name={ name }
                onChange={ onChange } />
                <span className={ style.label }>
                    { label }
                </span>
            </label>
        );
    }
}
XorOption.propTypes = {
    className: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.string,
    style: PropTypes.object,
};
XorOption.defaultProps = {
    className: '',
    defaultValue: null,
    onChange: () => {},
    onClick: () => {},
    label: '',
};

export default XorOption;
